<template>
  <userlanding>
    <div class="contactPage">
      <img src="/feedback.jpeg" />
      <div class="contentFeedback">
        <h1>Share Your Feedback</h1>
        <p class="core-sen">
          Our team at Sunshine Connected strives to best serve our users, and
          make the necessary changes to try meeting all of your needs. Please
          feel free to get in touch with us and leave some feedback - we welcome
          anything from comments to questions!<br />
          We look forward to hearing from you!
        </p>
        <a-form :form="form" @submit="handleSubmit" :layout="'vertical'">
          <a-form-item
            label="Last Name"
            required
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input  v-decorator="[
          'lastname',
          { rules: [{ required: true, message: 'Please input your Password!' }] },
        ]" placeholder="enter your last name" />
          </a-form-item>
          <a-form-item
            label="First Name"
            required
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input  v-decorator="[
          'firstname',
          { rules: [{ required: true, message: 'Please enter your first name!' }] },
        ]" placeholder="enter your first name" />
          </a-form-item>
          <a-form-item
            label="Email"
            required
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input  v-decorator="[
          'email',
          { rules: [{ required: true, message: 'Please enter your email!' }] },
        ]" placeholder="enter your email" />
          </a-form-item>
           <a-form-item
            label="Which do you most identify as ?"
            required
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-select  v-decorator="[
          'identification',
          { rules: [{ required: true, message: 'Please select your identification!' }] },
        ]" placeholder="your identification" >
              <a-select-option value="participant">Participant</a-select-option>
              <a-select-option value="volunteer">Volunteer</a-select-option>
              <a-select-option value="friend">Friend</a-select-option>
              <a-select-option value="family">Family Member</a-select-option>
              <a-select-option value="residence">Residence Staff</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            label="Feedback"
            required
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-textarea  v-decorator="[
          'feedback',
          { rules: [{ required: true, message: 'Please share your feedback!' }] },
        ]" placeholder="please share your feedback" />
          </a-form-item>
          <a-form-item :wrapper-col="buttonItemLayout.wrapperCol">
            <a-button html-type="submit" type="primary"> Submit </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </userlanding>
</template>

<script>
import { SendFeedback } from '../api';
import userlanding from "../components/userlanding.vue";
export default {
   beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'feedback' });
  },
  components: { userlanding },
  computed: {
    formItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
          }
        : {};
    },
    buttonItemLayout() {
      const { formLayout } = this;
      return formLayout === "horizontal"
        ? {
            wrapperCol: { span: 14, offset: 4 },
          }
        : {};
    },
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (!err) {

          SendFeedback(values)
          this.$message.success("Feedback Submitted")
          this.$router.push("/")
        }
      });
    },
  },
};
</script>

<style lang="less">
.contactPage {
  display: flex;
  flex-direction: row;
  gap: 5vw;
  min-height: 80vh;
  & > img {
    max-width: 50vw;
    object-fit: contain;
  }
  & > .contentFeedback {
    padding: 3vw;
    > .core-sen {
    font-size: 1.5rem;
  }
  }

}
@media screen and (max-width:1000px) {
  .contactPage {
    flex-direction: column;
    & > img {
      width: 100%;
    }
  }
}
</style>